<template>
  <div id="app">
    <div class="app-body">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style scoped lang="scss">
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  // width: 100vw;
  // height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #222;
  background-image: url("./assets/img/pc-bg.png");
}

.app-body {
  width: 100vw;
  max-width: 400px;
  height: 100vh;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue